import { CommonModule } from '@angular/common'
import { Component, CUSTOM_ELEMENTS_SCHEMA, input, ViewEncapsulation } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { MatDividerModule } from '@angular/material/divider'
import { MatIconModule } from '@angular/material/icon'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { PdfExportService } from 'src/app/service/pdf/pdf-export.service'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { Dictionary } from '../../models/main/dictionary'
import { DdcButtonROneComponent } from '../ddc-button-r-one/ddc-button-r-one.component'
import { DdcButtonSOneComponent } from '../ddc-button-s-one/ddc-button-s-one.component'

@Component({
  selector: 'ddc-generate-pdf-mobile-sheet',
  templateUrl: './ddc-generate-pdf-mobile-sheet.component.html',
  styleUrl: './ddc-generate-pdf-mobile-sheet.component.scss',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [
    AngularMaterialsModules,
    CommonModule,
    MatIconModule,
    MatDividerModule,
    DdcButtonSOneComponent,
    DdcButtonROneComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DdcGeneratePdfMobileSheetComponent {
  dictionary = input<Dictionary>(undefined) // Replace 'any' with the actual type of your dictionary

  _isDarkTheme = false
  _isLightTheme = true
  _isPaperTheme = false

  loading = false
  error: string | null = null
  pdfUrl: string | null = null

  constructor(
    private _themeService: ThemeService,
    private _dialogRef: MatDialogRef<DdcGeneratePdfMobileSheetComponent>,
    private _pdfExportService: PdfExportService,
  ) {
    this._themeService.theme$.subscribe(theme => {
      this._isDarkTheme = theme === 'dark-theme'
      this._isLightTheme = theme === 'light-theme'
      this._isPaperTheme = theme === 'paper-theme'
    })
  }

  onGeneratePdf(): void {
    const dict = this.dictionary()
    if (!dict?.id) {
      this.error = 'Dictionary ID is missing.'
      return
    }
    this.loading = true
    this.error = null
    this.pdfUrl = null
    this._pdfExportService.generatePDF({ dictionaryId: dict.id }).subscribe({
      next: res => {
        this.loading = false
        if (res.success) {
          this.pdfUrl = 'PDF generated successfully. Go to your library to view it.'
        } else {
          this.error = res.message || 'Failed to generate PDF.'
        }
      },
      error: err => {
        this.loading = false
        this.error = err?.message || 'Failed to generate PDF.'
      },
    })
  }

  onCancel(): void {
    this._dialogRef.close()
  }
}
